import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';
import { useForm } from 'react-hook-form';
import whatsappUtils from 'api/whatsapp-utils';
import MuiMultSelect from 'newComponents/MuiMultSelect';
import { useMessage } from 'newComponents/ChatWhatsapp/context/MessageContext';
import { useNotifyAlert } from 'context/NotifyAlert';

const NewDepartmentModal = ( {
	onClose,
	position,
	modalRef,
	addDepartment,
	departmentToEdit,
	handleSetDepartmentToEdit
} ) => {
	const { users, handleSelectionUsersChange, selectedUsers } = useMessage();
	const { register, handleSubmit, setValue } = useForm();
	const { setShowNotify } = useNotifyAlert();
	const handleSubmitForm = async ( data ) => {
		if( departmentToEdit ) {
			const newDepartment = await whatsappUtils
				.updateDepartment( { id: departmentToEdit.id, name: data.name } );
			addDepartment( { ...newDepartment, users: departmentToEdit.users } );
			setShowNotify( {
				status : 'success',
				text   : 'Departamento atualizado com sucesso!'
			} );
			handleCloseModal();
			return;
		}
		const newDepartment = await whatsappUtils.createDepartment( { ...data, users: selectedUsers } );
		addDepartment( newDepartment );
		setShowNotify( {
			status : 'success',
			text   : 'Departamento criado com sucesso!'
		} );
		handleCloseModal();
	};

	useEffect( () => {
		if( departmentToEdit ) {
			setValue( 'name', departmentToEdit.name );
			handleSelectionUsersChange( departmentToEdit.users.map( user => user.id ) );
		}
	}, [ departmentToEdit, setValue, handleSelectionUsersChange ] );

	const handleCloseModal = () => {
		setValue( 'name', '' );
		handleSelectionUsersChange( [] );
		handleSetDepartmentToEdit( null );
		onClose();
	};

	return (
		<S.ModalContainer position={position} ref={modalRef}>
			<S.ModalTitle>{departmentToEdit ? 'Editar Departamento' :'Novo Departamento' }</S.ModalTitle>
			<S.ModalLabel htmlFor="name">Nome do Departamento
				<S.ModalInput type="text" placeholder="Insira o nome do departamento" {...register( 'name' )} />
			</S.ModalLabel>
			{!departmentToEdit && <MuiMultSelect
				options={users}
				selected={selectedUsers ?? []}
				callback={handleSelectionUsersChange}
				label="Usuários"
			/>}

			<S.ModalButtons>
				<S.CancelButton onClick={handleCloseModal}>Cancelar</S.CancelButton>
				<S.SaveButton onClick={handleSubmit( handleSubmitForm )}>{departmentToEdit ? 'Editar' : 'Criar'}</S.SaveButton>
			</S.ModalButtons>
		</S.ModalContainer>
	);
};

NewDepartmentModal.propTypes = {
	onClose  : PropTypes.func.isRequired,
	position : PropTypes.shape( {
		top  : PropTypes.number.isRequired,
		left : PropTypes.number.isRequired
	} ).isRequired,
	modalRef                  : PropTypes.object.isRequired,
	addDepartment             : PropTypes.func.isRequired,
	departmentToEdit          : PropTypes.object,
	handleSetDepartmentToEdit : PropTypes.func.isRequired
};

export default NewDepartmentModal;
